import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

import SLogo from '../Assets/Shyne_S.png';
import SText from '../Assets/Shyne_Text.png';
import CalendlyModal from '../Consultation/CalendlyModal/CalendlyModal';

import { FiMenu, FiX, FiHome, FiInfo, FiMail, FiBookOpen, FiLayers, FiChevronDown  } from 'react-icons/fi';

function Navbar() {
  const [modalOpen, setModalOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
    setServicesOpen(false);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-inner">
          <div className="logo-wrapper">
            <Link to="/" onClick={closeMenu}>
              <img src={SLogo} alt="Shyne Symbol" className="logo-s" />
              <img src={SText} alt="Shyne Text" className="logo-text" />
            </Link>
          </div>

          <button
            className="hamburger-icon"
            onClick={() => {
              setMenuOpen(!menuOpen);
              setServicesOpen(false);
            }}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            type="button"
          >
            {menuOpen ? <FiX size={26} /> : <FiMenu size={26} />}
          </button>

          <div className={`nav-right ${menuOpen ? 'open' : ''}`}>
            <ul className="navbar-links">
              <li>
                <Link to="/" onClick={closeMenu}>
                  <FiHome className="nav-icon" />
                  Home
                </Link>
              </li>

              <li>
                <Link to="/about" onClick={closeMenu}>
                  <FiInfo className="nav-icon" />
                  About Us
                </Link>
              </li>

              <li className={`nav-dropdown ${servicesOpen ? 'open' : ''}`}>
                <button
                  className="nav-dropdown-trigger"
                  onClick={() => setServicesOpen(!servicesOpen)}
                  type="button"
                  aria-expanded={servicesOpen}
                >
                  <FiLayers className="nav-icon" />
                  Services
                  <FiChevronDown className="dropdown-arrow" />
                </button>

                <div className="nav-dropdown-menu">
                  <Link to="/services" onClick={closeMenu}>
                    All Services
                  </Link>
                  <Link to="/services/logo-design" onClick={closeMenu}>
                    Logo Design
                  </Link>
                  <Link to="/services/web-design" onClick={closeMenu}>
                    Website Design
                  </Link>
                  <Link to="/services/business-cards" onClick={closeMenu}>
                    Business Cards
                  </Link>
                  <Link to="/services/social-media-design" onClick={closeMenu}>
                    Social Media Design
                  </Link>
                  <Link to="/services/seo-marketing" onClick={closeMenu}>
                    SEO & Marketing
                  </Link>
                </div>
              </li>

              <li>
                <Link to="/blog" onClick={closeMenu}>
                  <FiBookOpen className="nav-icon" />
                  Blog
                </Link>
              </li>

              <li>
                <Link to="/contact" onClick={closeMenu}>
                  <FiMail className="nav-icon" />
                  Contact Us
                </Link>
              </li>
            </ul>

            <button
              className="consultation-button"
              onClick={() => {
                setModalOpen(true);
                closeMenu();
              }}
              type="button"
            >
              BOOK FREE CONSULTATION
            </button>
          </div>
        </div>
      </nav>

      <CalendlyModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}

export default Navbar;